<template>
<div>
  <validation-observer ref="simpleRules">
    <b-form>

      <!-- Page Header -->
      <!-- <div class="d-flex align-items-center justify-content-between mb-2">
        <div class="d-flex align-items-center">
          <b-button variant="flat-secondary" class="btn-icon mr-1" :to="{ name: 'enquiry-lists' }">
            <feather-icon icon="ArrowLeftIcon" />
          </b-button>
          <div>
            <h4 class="mb-0">Edit Enquiry</h4>
            <small class="text-muted" v-if="input.code">#{{ input.code }}</small>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <b-button variant="outline-primary" class="mr-1" @click="formmail_show">
            <feather-icon icon="MailIcon" class="mr-50" />
            Generate Email
          </b-button>
          <b-button variant="primary" @click.prevent="validationForm">
            <feather-icon icon="SaveIcon" class="mr-50" />
            Save Changes
          </b-button>
        </div>
      </div> -->

      <b-row>

        <!-- Left column: Client card + comments -->
        <b-col md="4">
          <b-card class="mb-2">
            <div class="text-center mb-2">
                <div class="client-avatar mx-auto mb-1">
                    <img
                    v-if="input.avatar_url"
                    :src="input.avatar_url"
                    alt="Avatar"
                    class="client-avatar__image"
                    />

                    <template v-else>
                    {{ input.firstname ? input.firstname.charAt(0).toUpperCase() : '?' }}
                    </template>
                </div>

                <h5 class="mb-0">{{ input.firstname }} {{ input.lastname }}</h5>

                <b-badge
                    v-if="clientTypeLabel"
                    :variant="clientTypeVariant"
                    class="mt-50"
                >
                    {{ clientTypeLabel }}
                </b-badge>
            </div>

            <div class="mb-2">
              <div v-if="input.email && input.email.length" class="contact-row mb-75">
                <feather-icon icon="MailIcon" size="14" class="text-muted mr-50 mt-25" />
                <div>
                  <a v-for="(em, i) in input.email" :key="i" :href="'mailto:'+em" class="d-block text-body small">{{ em }}</a>
                </div>
              </div>
              <div v-if="input.phone && input.phone.length" class="contact-row">
                <feather-icon icon="PhoneIcon" size="14" class="text-muted mr-50 mt-25" />
                <div>
                  <a v-for="(ph, i) in input.phone" :key="i" :href="'tel:'+ph" class="d-block text-body small">{{ ph }}</a>
                </div>
              </div>
              <div v-if="clientLineId" class="contact-row mt-75">
                <feather-icon icon="MessageCircleIcon" size="14" class="text-muted mr-50" />
                <span class="small text-body">{{ clientLineId }}</span>
              </div>
            </div>

            <div v-if="coAgentSubmission">
              <hr class="my-1" />
              <div class="d-flex align-items-center justify-content-between mb-75">
                <div class="section-label">Co-Agent Property Submission</div>
                <b-badge :variant="coAgentStatusVariant(coAgentSubmission.co_agent_status)">
                  {{ coAgentSubmission.co_agent_status || 'pending' }}
                </b-badge>
              </div>
              <b-button
                v-if="!['approved','withdrawn'].includes(coAgentSubmission.co_agent_status) && userData && [1,2].includes(userData.type_id)"
                variant="success"
                block
                size="sm"
                :disabled="approvingCoAgent"
                class="mb-75"
                @click="approveCoAgentSubmission"
              >
                <feather-icon icon="CheckCircleIcon" class="mr-50" />
                {{ approvingCoAgent ? 'Approving...' : 'Approve' }}
              </b-button>
            </div>

            <div v-if="coAgentSubmission && coAgentSubmission.customer && (coAgentSubmission.customer.firstname || coAgentSubmission.customer.email)">
              <div class="section-label mb-75">Customer</div>
              <div class="agent-customer-row">
                <div class="agent-customer-avatar">
                  {{ coAgentSubmission.customer.firstname ? coAgentSubmission.customer.firstname.charAt(0).toUpperCase() : '?' }}
                </div>
                <div class="flex-grow-1 min-width-0">
                  <div class="small font-weight-bold">{{ coAgentSubmission.customer.firstname }} {{ coAgentSubmission.customer.lastname }}</div>
                  <div v-if="coAgentSubmission.customer.phone" class="text-muted" style="font-size:0.75rem;">{{ coAgentSubmission.customer.phone }}</div>
                </div>
              </div>
              <div v-if="coAgentSubmission.customer.email" class="contact-row mt-50">
                <feather-icon icon="MailIcon" size="14" class="text-muted mr-50" />
                <a :href="'mailto:' + coAgentSubmission.customer.email" class="small text-muted">{{ coAgentSubmission.customer.email }}</a>
              </div>

              <div v-if="coAgentCustomerMatches && coAgentCustomerMatches.length" class="mt-75">
                <b-badge variant="light-warning" class="mb-50">
                  <feather-icon icon="AlertTriangleIcon" size="12" class="mr-25" />
                  Possible match ({{ coAgentCustomerMatches.length }})
                </b-badge>
                <div v-for="match in coAgentCustomerMatches" :key="match.id" class="d-flex align-items-center mt-25" style="gap:6px;">
                  <router-link :to="{ name: 'clients-edit', params: { id: match.id } }" target="_blank" class="small font-weight-bold">
                    {{ match.firstname }} {{ match.lastname }}
                  </router-link>
                  <span v-if="match.email" class="text-muted" style="font-size:0.72rem;">{{ Array.isArray(match.email) ? match.email[0] : match.email }}</span>
                </div>
              </div>
            </div>

            <b-button variant="outline-primary" block :to="{ name: 'clients-edit', params: { id: input.user_id } }" class="mt-1">
              <feather-icon icon="UserIcon" class="mr-50" />
              View Profile
            </b-button>
          </b-card>

          <form-comment v-if="id" :id="id" />

          <!-- Assigned User Card -->
          <b-card v-if="assignedUser" class="mb-2">
            <div class="section-label mb-1">Assigned To</div>
            <div class="d-flex align-items-center mb-1">
              <div class="client-avatar client-avatar--sm mr-1">
                {{ assignedUser.firstname ? assignedUser.firstname.charAt(0).toUpperCase() : '?' }}
              </div>
              <div>
                <div class="font-weight-bold">{{ assignedUser.firstname }} {{ assignedUser.lastname }}</div>
                <b-badge variant="light-warning" class="mr-50">{{ assign_user_type === 'agent' ? 'Agent' : 'Admin' }}</b-badge>
              </div>
            </div>
            <div v-if="assignedUser.email" class="contact-row mb-50">
              <feather-icon icon="MailIcon" size="14" class="text-muted mr-50" />
              <a :href="'mailto:' + assignedUser.email" class="small text-body">{{ assignedUser.email }}</a>
            </div>
            <div v-if="assignedUser.phone" class="contact-row">
              <feather-icon icon="PhoneIcon" size="14" class="text-muted mr-50" />
              <a :href="'tel:' + assignedUser.phone" class="small text-body">{{ assignedUser.phone }}</a>
            </div>
          </b-card>
        </b-col>

        <!-- Right column: Enquiry form -->
        <b-col md="8">
          <b-card>

            <!-- Basic Info -->
            <div class="section-label mb-1">Basic Info</div>
            <b-row>
              <b-col md="12">
                <b-form-group label="Title">
                  <b-form-input v-model="input.title" placeholder="Enquiry title" />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Description">
                  <b-form-textarea v-model="input.description" placeholder="Description" rows="3" />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Looking For">
                  <v-select
                    v-model="input.looking"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="(option) => option.id"
                    :options="option_looking"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="For">
                  <v-select
                    v-model="input.fors"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="option_fors"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Source">
                  <v-select
                    v-model="input.enquiry_source"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="option_sources"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Bedroom">
                  <b-form-spinbutton v-model="input.bedroom" size="md" class="w-100" />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Bathroom">
                  <b-form-spinbutton v-model="input.bathroom" size="md" class="w-100" />
                </b-form-group>
              </b-col>
            </b-row>

            <hr class="my-2" />

            <!-- Budget -->
            <div class="section-label mb-1">Budget (THB)</div>
            <b-row>
              <b-col md="6">
                <b-form-group label="Buy Min">
                  <b-form-input v-model="input.buy_min" placeholder="0" />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Buy Max">
                  <b-form-input v-model="input.buy_max" placeholder="0" />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Rent Min">
                  <b-form-input v-model="input.rent_min" placeholder="0" />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Rent Max">
                  <b-form-input v-model="input.rent_max" placeholder="0" />
                </b-form-group>
              </b-col>
            </b-row>

            <hr class="my-2" />

            <!-- Location -->
            <div class="section-label mb-1">Location Preferences</div>
            <b-row>
              <b-col md="6">
                <b-form-group label="Zone">
                  <v-select
                    v-model="input.zone_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :reduce="(option) => option.id"
                    :options="zone.map((g) => ({ name: g.name[currentLocale], id: g.id }))"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="BTS Interest">
                  <v-select
                    v-model="input.bts_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="bts"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="MRT Interest">
                  <v-select
                    v-model="input.mrt_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="mrt"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Airport Link Interest">
                  <v-select
                    v-model="input.airport_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="airport"
                  />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Property Pin Interest">
                  <validation-provider #default="{ errors }" rules="min:0" name="place_id">
                    <vue-autosuggest
                      ref="autocomplete"
                      name="place_id"
                      v-model="place_id"
                      :suggestions="suggestions"
                      :input-props="inputProps"
                      :section-configs="sectionConfigs"
                      :render-suggestion="renderSuggestion"
                      :get-suggestion-value="getSuggestionValue"
                      @input="fetchResults"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <hr class="my-2" />

            <!-- CC Emails -->
            <div class="section-label mb-1">CC Emails</div>
            <b-form-group>
              <b-input-group>
                <b-form-input
                  v-model="newEmail"
                  type="email"
                  placeholder="Enter email and press Add"
                  @keyup.enter="addEmail"
                />
                <b-input-group-append>
                  <b-button variant="primary" @click="addEmail">Add</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <div class="email-chips mb-2" v-if="input.ccEmails && input.ccEmails.length">
              <span v-for="(email, index) in input.ccEmails" :key="index" class="email-chip">
                {{ email.email ? email.email : email }}
                <feather-icon
                  v-if="email.is_default ? !email.is_default : 1"
                  icon="XIcon"
                  size="12"
                  class="remove-chip"
                  @click="removeEmail(index)"
                />
              </span>
            </div>

            <hr class="my-2" />

            <!-- Subscription -->
            <div class="subscription-row mb-2">
              <div>
                <div class="font-weight-bold">Email Subscription</div>
                <small class="text-muted">Receive property listing emails</small>
              </div>
              <validation-provider #default="{ errors }" name="is_subscript">
                <b-form-checkbox v-model="input.is_subscript" class="custom-control-primary" switch />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>

            <!-- <hr class="my-2" /> -->

            <!-- User Assign -->
            <!-- <div class="section-label mb-1">User Assign</div>
            <b-row>
              <b-col md="6">
                <b-form-group label="User Type">
                  <v-select
                    v-model="assign_user_type"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="o => o.id"
                    :options="user_type_options"
                    placeholder="Select type..."
                    @input="onUserTypeChange"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Assign To">
                  <v-select
                    v-model="input.assigned_user_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="fullname"
                    :reduce="o => o.id"
                    :options="assigned_users_list"
                    :disabled="!assign_user_type"
                    placeholder="Select user..."
                    @input="onAssignUserChange"
                  />
                </b-form-group>
              </b-col>
            </b-row> -->

            <!-- Agent's Customers -->
            <template v-if="assign_user_type === 'agent' && input.assigned_user_id">
              <div class="section-label mb-1">Agent's Customers</div>
              <div v-if="agent_customers_loading" class="text-muted small mb-1">Loading...</div>
              <div v-else-if="agent_customers.length" class="table-responsive mb-1">
                <table class="table b-table table-striped table-hover table-sm mb-0">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="c in agent_customers" :key="c.id">
                      <td>
                        <router-link :to="{ name: 'clients-edit', params: { id: c.id } }" target="_blank">
                          {{ c.firstname }} {{ c.lastname }}
                        </router-link>
                      </td>
                      <td><a v-if="c.email" :href="'mailto:' + c.email" class="small text-muted">{{ c.email }}</a></td>
                      <td><a v-if="c.phone" :href="'tel:' + c.phone" class="small text-muted">{{ c.phone }}</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="text-muted small mb-1">No customers found for this agent.</div>
            </template>

            <b-button variant="primary" @click.prevent="validationForm">
              <feather-icon icon="SaveIcon" class="mr-50" />
              Save Changes
            </b-button>

          </b-card>
        </b-col>

        <!-- Selected Properties -->
        <b-col md="12">
          <b-card-actions action-collapse title="Selected Properties">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="text-muted small">
                {{ properties_selected.length ? properties_selected.length + ' propert' + (properties_selected.length === 1 ? 'y' : 'ies') + ' selected' : 'No properties selected' }}
              </span>
              <div class="d-flex align-items-center">
                <b-button variant="primary" size="sm" class="mr-1" @click="openPropertyModal">
                  <feather-icon icon="PlusIcon" class="mr-50" />
                  Add Properties
                </b-button>
                <b-button variant="outline-primary" size="sm" @click="formmail_show">
                  <feather-icon icon="MailIcon" class="mr-50" />
                  Generate Email
                </b-button>
              </div>
            </div>

            <div v-if="!properties_selected.length" class="empty-state">
              <feather-icon icon="InboxIcon" size="36" class="text-muted mb-1" />
              <p class="text-muted mb-0">No properties added yet. Click "Add Properties" to browse and select.</p>
            </div>

            <div v-else class="table-responsive">
              <table class="table b-table table-striped table-hover">
                <thead>
                  <tr>
                    <th style="width:40px"></th>
                    <th>Image</th>
                    <th>Property</th>
                    <th>Owner</th>
                    <th>Unit / Floor</th>
                    <th>Type</th>
                    <th>Close Deal</th>
                    <th>BD</th>
                    <th>SQM</th>
                    <th>Rent (THB)</th>
                    <th>Sale (THB)</th>
                    <th>Exp/Avail</th>
                    <!-- <th>Rating</th> -->
                    <th>Furniture</th>
                    <th>BTS</th>
                    <th>MRT</th>
                    <th>Zone</th>
                  </tr>
                </thead>

                <tr v-for="item in properties_selected" :key="item.id">
                <td>
                    <feather-icon icon="Trash2Icon" class="text-danger cursor-pointer" @click="remove_property(item.id)" />
                </td>
                <td>
                    <b-img
                    class="img_property"
                    v-if="item.property_images[0]"
                    :src="item.property_images[0].fullfilepath"
                    />
                    <b-img
                    class="img_property"
                    v-else
                    :src="'https://digitalnation.sgp1.cdn.digitaloceanspaces.com/findbangkokroom/storage/1698858264911-picture.png'"
                    />
                </td>
                <td>
                    <div class="list-property">
                    <router-link :to="{ name: 'property-edit', params: { id: item.id } }">{{ item.property_code }}</router-link>
                    <b-badge v-if="item.action_id == 1" variant="light-secondary">{{ item.action_name }}</b-badge>
                    <b-badge v-if="item.action_id == 2" variant="light-info">{{ item.action_name }}</b-badge>
                    <b-badge v-if="item.action_id == 3" variant="light-success">{{ item.action_name }}</b-badge>
                    <b-badge v-if="item.action_id == 4" variant="light-warning">{{ item.action_name }}</b-badge>
                    <b-badge v-if="item.status_id == 1" variant="light-success">{{ item.status_code }}</b-badge>
                    <b-badge v-else variant="light-secondary">{{ item.status_code }}</b-badge>
                    <b-badge variant="light-primary" class="ml-25" @click="doCopy(item.place_name && item.place_name[currentLocale] ? item.place_name[currentLocale] : (item.place_title || ''), item.property_code)">
                        <feather-icon icon="CopyIcon" size="14" />
                    </b-badge>
                    <div class="text-muted small mt-25">{{ item.place_name && item.place_name[currentLocale] ? item.place_name[currentLocale] : (item.place_title || '') }}</div>
                    </div>
                </td>
                <td>
                    <router-link :to="{ name: 'clients-edit', params: { id: item.owner_id } }" target="_blank">
                    {{ item.owner_firstname }} {{ item.owner_lastname }}
                    </router-link>
                    <div><a :href="'mailto:'+item.owner_email" class="small text-muted">{{ item.owner_email }}</a></div>
                    <div><a :href="'tel:'+item.owner_phone" class="small text-muted">{{ item.owner_phone }}</a></div>
                </td>
                <td>{{ item.units }} {{ item.address_no }}<br /><small class="text-muted">Fl {{ item.floors }}</small></td>
                <td>{{ item.type_name }}</td>
                <td>
                    <b-button variant="flat-primary" size="sm" :to="{ name: 'close-deal-create', params: { id: id, property_id: item.id } }">Close</b-button>
                </td>
                <td>{{ item.bedroom }}</td>
                <td>{{ item.sqm }}</td>
                <td>{{ item.rent_price | getcomma }}</td>
                <td>{{ item.sale_price | getcomma }}</td>
                <td>{{ item.exp }}</td>
                <!-- <td>{{ item.rating }}</td> -->
                <td>{{ item.furniture_name }}</td>
                <td>{{ item.bts_name }}</td>
                <td>{{ item.mrt_name }}</td>
                <td>{{ item.zone_name }}</td>
                </tr>
                
              </table>
            </div>
          </b-card-actions>
        </b-col>

      </b-row>

  <!-- Property Picker Modal -->
  <b-modal
    v-model="showPropertyModal"
    title="Add Properties"
    size="xl"
    no-close-on-backdrop
    body-class="p-0"
  >
    <div class="property-modal-split">

      <!-- Mobile filter backdrop -->
      <div v-if="showMobileFilters" class="mobile-filter-backdrop" @click="showMobileFilters = false" />

      <!-- Left: Filter Panel -->
      <div class="property-modal-sidebar" :class="{ 'mobile-open': showMobileFilters }">
        <div class="d-flex align-items-center justify-content-between mb-1">
          <div class="section-label">Filters</div>
          <feather-icon icon="XIcon" size="16" class="cursor-pointer d-md-none text-muted" @click="showMobileFilters = false" />
        </div>

        <b-form-group label="Project Name" label-class="filter-field-label">
          <b-form-input v-model="modalPlaceKeyword" placeholder="project name" size="sm" />
        </b-form-group>
        <b-form-group label="Property Code" label-class="filter-field-label">
          <b-form-input v-model="propertyfilter" placeholder="e.g. P001" size="sm" />
        </b-form-group>
        <b-form-group label="Owner Name" label-class="filter-field-label">
          <b-form-input v-model="ownerfilter" placeholder="First name, last name, phone or email" size="sm" />
        </b-form-group>
        <b-form-group label="Building" label-class="filter-field-label">
          <b-form-input v-model="building" placeholder="Building name" size="sm" />
        </b-form-group>
        <b-form-group label="Unit" label-class="filter-field-label">
          <b-form-input v-model="unit" placeholder="Unit no." size="sm" />
        </b-form-group>
        <b-form-group label="Type" label-class="filter-field-label">
          <b-form-input v-model="types" placeholder="e.g. Studio, Duplex" size="sm" />
        </b-form-group>
        <b-form-group label="Floor" label-class="filter-field-label">
          <b-form-input v-model="floor" placeholder="Floor no." size="sm" />
        </b-form-group>
        <b-form-group label="Bedroom" label-class="filter-field-label">
          <b-form-input v-model="bedroom" placeholder="No. of bedrooms" size="sm" />
        </b-form-group>
        <b-form-group label="SQM" label-class="filter-field-label">
          <b-form-input :value="sqm_min_display" @input="v => handleNumericInput('sqm_min', 'sqm_min_display', v)" placeholder="Min" size="sm" class="mb-50" />
          <b-form-input :value="sqm_max_display" @input="v => handleNumericInput('sqm_max', 'sqm_max_display', v)" placeholder="Max" size="sm" />
        </b-form-group>
        <b-form-group label="Rent Price (THB)" label-class="filter-field-label">
          <b-form-input :value="price_rent_min_display" @input="v => handleNumericInput('price_rent_min', 'price_rent_min_display', v)" placeholder="Min" size="sm" class="mb-50" />
          <b-form-input :value="price_rent_max_display" @input="v => handleNumericInput('price_rent_max', 'price_rent_max_display', v)" placeholder="Max" size="sm" />
        </b-form-group>
        <b-form-group label="Sale Price (THB)" label-class="filter-field-label">
          <b-form-input :value="price_sale_min_display" @input="v => handleNumericInput('price_sale_min', 'price_sale_min_display', v)" placeholder="Min" size="sm" class="mb-50" />
          <b-form-input :value="price_sale_max_display" @input="v => handleNumericInput('price_sale_max', 'price_sale_max_display', v)" placeholder="Max" size="sm" />
        </b-form-group>

        <b-form-checkbox
          v-model="statusId"
          value="1"
          @input="change_status"
          class="custom-control-primary mb-2"
        >
          Available Only
        </b-form-checkbox>

        <b-button variant="outline-secondary" block size="sm" @click="resetModalFilters">
          <feather-icon icon="RefreshCwIcon" size="13" class="mr-50" />
          Reset Filters
        </b-button>
      </div>

      <!-- Right: Results Table -->
      <div class="property-modal-results">
        <!-- Mobile filter toggle bar -->
        <div class="mobile-filter-bar d-flex d-md-none align-items-center justify-content-between px-1 py-75">
          <b-button variant="outline-secondary" size="sm" @click="showMobileFilters = true">
            <feather-icon icon="SlidersIcon" size="14" class="mr-50" />
            Filters
            <b-badge v-if="activeFilterCount > 0" variant="primary" pill class="ml-25">{{ activeFilterCount }}</b-badge>
          </b-button>
          <small class="text-muted">{{ totalpRows }} result{{ totalpRows !== 1 ? 's' : '' }}</small>
        </div>
        <b-table
          striped
          hover
          responsive
          no-local-sorting
          :items="properties"
          :fields="fields_properties"
          :sort-by.sync="modalSortBy"
          :sort-desc.sync="modalSortDesc"
          show-empty
          empty-text="No matching records found"
          class="mb-0"
          @sort-changed="onModalSortChanged"
        >
          <template #cell(id)="data">
            <b-form-checkbox
              v-model="modalSelected"
              :value="data.item"
              :checked="modalSelected.some(s => s.id === data.item.id)"
            />
          </template>

          <template #cell(units)="data">
            {{ data.item.units }} {{ data.item.address_no }}
          </template>

          <template #cell(property)="data">
            <div class="list-property">
              <router-link :to="{ name: 'property-edit', params: { id: data.item.id } }" target="_blank">{{ data.item.property_code }}</router-link>
              <b-badge v-if="data.item.action_id == 1" variant="light-secondary">{{ data.item.action_name }}</b-badge>
              <b-badge v-if="data.item.action_id == 2" variant="light-info">{{ data.item.action_name }}</b-badge>
              <b-badge v-if="data.item.action_id == 3" variant="light-success">{{ data.item.action_name }}</b-badge>
              <b-badge v-if="data.item.action_id == 4" variant="light-warning">{{ data.item.action_name }}</b-badge>
              <b-badge v-if="data.item.status_id == 1" variant="light-success">{{ data.item.status_code }}</b-badge>
              <b-badge v-else variant="light-secondary">{{ data.item.status_code }}</b-badge>
              <div class="text-muted small">{{ data.item.place_name && data.item.place_name[currentLocale] ? data.item.place_name[currentLocale] : (data.item.place_title || '') }}</div>
            </div>
          </template>

          <template #cell(image)="data">
            <b-button variant="flat-primary" class="pb0" :to="{ name: 'property-upload', params: { id: data.item.id } }" target="_blank">
              <b-img class="img_property" v-if="data.item.property_images && data.item.property_images[0]" :src="data.item.property_images[0].fullfilepath" />
              <b-img class="img_property" v-else :src="'https://digitalnation.sgp1.cdn.digitaloceanspaces.com/findbangkokroom/storage/1698858264911-picture.png'" />
            </b-button>
          </template>

          <template #cell(owner)="data">
            <div>{{ data.item.owner_firstname }} {{ data.item.owner_lastname }}</div>
            <a :href="'mailto:'+data.item.owner_email" class="small text-muted">{{ data.item.owner_email }}</a>
          </template>

          <template #cell(price_rent)="data">
            {{ data.item.rent_price | getcomma }}
          </template>

          <template #cell(price_sale)="data">
            {{ data.item.sale_price | getcomma }}
          </template>
        </b-table>

        <b-pagination
          v-if="totalpRows > 0"
          v-model="currentpPage"
          :total-rows="totalpRows"
          :per-page="perPagep"
          align="center"
          size="sm"
          class="my-1 px-1"
        />
      </div>
    </div>

    <!-- Modal Footer -->
    <template #modal-footer>
      <div class="modal-footer-inner w-100">
        <span class="text-muted small modal-footer-count">
          <template v-if="modalSelected.length">
            <b-badge variant="primary" pill>{{ modalSelected.length }}</b-badge>
            propert{{ modalSelected.length === 1 ? 'y' : 'ies' }} selected
          </template>
          <template v-else>Select properties from the list</template>
        </span>
        <div class="modal-footer-actions">
          <b-button variant="outline-secondary" @click="showPropertyModal = false">Cancel</b-button>
          <b-button variant="primary" :disabled="!modalSelected.length" @click="applyModalSelection">
            Add Selected
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
    </b-form>
  </validation-observer>

  <!-- Email Sidebar -->
  <b-sidebar
    id="sidebar-right"
    bg-variant="white"
    no-header
    right
    backdrop
    shadow
    v-model="isSidebarMailOpen"
    class="side-bar-responsive"
  >
    <template>
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">Send Mail</h5>
        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="formmail_close" />
      </div>
      <div v-if="isSidebarMailOpen">
        <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
          <b-form class="p-2" @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm">
            <b-row>
              <b-col sm="12">
                <validation-provider #default="validationContext" name="Header-Mail" rules="required">
                  <b-form-group label="Header Mail" label-for="Header-Mail">
                    <b-form-input id="Header-Mail" v-model="mail.subject" placeholder="Property Listing for you" />
                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col sm="6">
                <validation-provider #default="validationContext" name="MailTo" rules="required">
                  <b-form-group label="Mail To" label-for="MailTo">
                    <b-form-input id="MailTo" v-model="mail.mailto" placeholder="Enter emails separated by commas" />
                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col sm="6">
                <b-form-group label="CC Mail" label-for="ccMail">
                  <b-form-input id="ccMail" v-model="mail.mailcc" placeholder="Enter emails separated by commas" />
                </b-form-group>
              </b-col>
              <b-col sm="12" class="q-description">
                <validation-provider #default="validationContext" name="message" rules="required">
                  <b-form-group>
                    <label>Message</label>
                    <quill-editor style="height: 150px" v-model="mail.message" />
                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12">
                <b-button variant="primary" type="submit" @click.prevent="validationMailForm">Submit</b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>

        <div class="">
          <b-table
            striped
            hover
            responsive
            :per-page="perPage"
            :current-page="currentpsPage"
            :items="properties_selected"
            :fields="fields_propertiesmail"
            show-empty
            empty-text="No matching records found"
          >
            <template #head(id)>
              <b-form-checkbox title="Toggle Select All" @input="selectAll" v-model="selectAlled" />
            </template>
            <template #cell(id)="data">
              <input type="checkbox" v-model="pmails" :value="data.item.id" />
            </template>
            <template #cell(units)="data">
              {{ data.item.units }} {{ data.item.address_no }}
            </template>
            <template #cell(close_deal)="data">
              <b-button variant="flat-primary" class="pb0" :to="{ name: 'close-deal-create', params: { id: id, property_id: data.item.id } }">close</b-button>
            </template>
            <template #cell(property)="data">
              <div class="list-property">
                <router-link :to="{ name: 'property-edit', params: { id: data.item.id } }">{{ data.item.property_code }}</router-link>
                <b-badge v-if="data.item.action_id == 1" variant="light-secondary">{{ data.item.action_name }}</b-badge>
                <b-badge v-if="data.item.action_id == 2" variant="light-info">{{ data.item.action_name }}</b-badge>
                <b-badge v-if="data.item.action_id == 3" variant="light-success">{{ data.item.action_name }}</b-badge>
                <b-badge v-if="data.item.action_id == 4" variant="light-warning">{{ data.item.action_name }}</b-badge>
                <b-badge v-if="data.item.status_id == 1" variant="light-success">{{ data.item.status_code }}</b-badge>
                <b-badge v-else variant="light-secondary">{{ data.item.status_code }}</b-badge>
                <br />
                {{ data.item.place_name && data.item.place_name[currentLocale] ? data.item.place_name[currentLocale] : (data.item.place_title || '') }}<br /><br />
              </div>
            </template>
            <template #cell(image)="data">
              <b-button variant="flat-primary" class="pb0" :to="{ name: 'property-upload', params: { id: data.item.id } }">
                <b-img class="img_property" v-if="data.item.property_images && data.item.property_images[0]" :src="data.item.property_images[0].fullfilepath" />
                <b-img class="img_property" v-else :src="'https://digitalnation.sgp1.cdn.digitaloceanspaces.com/findbangkokroom/storage/1698858264911-picture.png'" />
              </b-button>
            </template>
            <template #cell(owner)="data">
              {{ data.item.owner_firstname }} {{ data.item.owner_lastname }}
            </template>
            <template #cell(price_rent)="data">
              {{ data.item.rent_price | getcomma }}
            </template>
            <template #cell(price_sale)="data">
              {{ data.item.sale_price | getcomma }}
            </template>
          </b-table>

          <b-pagination
            v-if="totalpsRows > 0"
            v-model="currentpsPage"
            :total-rows="totalpsRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
          />
        </div>

        <div ref="templateMail">
          <table style="margin: 0 auto;max-width: 680px;border-spacing: 0px;">
            <tr>
              <th style="text-align:left;padding: 10px;">
                <img style="max-width:200px" src="https://digitalnation.sgp1.cdn.digitaloceanspaces.com/realvestor/storage/1753862411754-Group-109.png">
              </th>
            </tr>
            <tr style="background: #fff;">
              <td style="padding: 20px;">
                <div style="text-align:right;font-weight:500;font-size:14px;">
                  <b>ENQUIRY ID</b> : #{{ input.code }}<br/>
                  {{ timestamp }}
                </div>
                <p style="font-size:14px;" v-html="mail.message"></p>
                <div v-for="(property, index) of properties_mail" :key="index" style="float: left;width: 50%;min-width: 300px;display: inline-block;height:450px;">
                  <div style="padding: 0 15px;">
                    <a target="_blank" :href="'https://findbangkokroom.com/condo/'+(property.place_name && property.place_name.en ? property.place_name.en.replace(/\s/g,'-') : '')+'/'+property.property_code">
                      <b-img class="img_property" v-if="property.property_images && property.property_images[0]" :src="property.property_images[0].fullfilepath" style="width:100%; object-fit:cover; height:170px;" />
                      <b-img class="img_property" v-else :src="'https://digitalnation.sgp1.cdn.digitaloceanspaces.com/findbangkokroom/storage/1698858264911-picture.png'" style="width:100%; object-fit:cover; height:170px;" />
                    </a>
                    <h3 style="margin: 5px 0;font-size: 16px;color:#333;">
                      <a target="_blank" :href="'https://findbangkokroom.com/condo/'+(property.place_name && property.place_name.en ? property.place_name.en.replace(/\s/g,'-') : '')+'/'+property.property_code">
                        <b>{{ property.place_name[currentLocale] }}</b>
                      </a>
                      <span style="font-size: 14px;font-weight: 400;">({{ property.property_code }})</span>
                    </h3>
                    <p style="margin:5px 0; font-size: 14px;line-height: 18px;">
                      Zone : {{ property.zone_name }}<br/>
                      <span v-if="property.bts_name"><b>BTS</b> {{ property.bts_name }} {{ property.bts_distance }} M.<br/></span>
                      <span v-if="property.mrt_name"><b>MRT</b> {{ property.mrt_name }}<br/></span>
                      <span v-if="property.airport_name">Airport Link : {{ property.airport_name }} {{ property.airportlink_distance }} M.<br/></span>
                      {{ property.bedroom }} Bedroom
                      {{ property.sqm }} sqm.<br/>
                      {{ property.floors }} Fl<br/>
                      {{ property.furniture_name }}<br/>
                      <b v-if="property.price_sale != 0" style="font-size: 15px;line-height: 24px;">Sale Price : {{ property.sale_price | getcomma }} THB</b><br/>
                      <b v-if="property.price_rent != 0" style="font-size: 15px;line-height: 24px;">Rent Price : {{ property.rent_price | getcomma }} THB</b>
                    </p>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div style="font-size:14px; padding:20px;">
                  <a href="https://therealtors.net/" target="_blank">www.therealtors.net</a><br />
                  29 Soi Sukhumvit 18,<br />
                  Klongtoey, Bangkok 10110
                  tel : <a href="tel:0974265147">: +66 97 426 5147</a><br />
                  Line : @therealtors<br />
                  whatsapp : +66 97 426 5147<br />
                  <a href="to:info@findbangkokroom.com">info@findbangkokroom.com</a>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </template>
  </b-sidebar>
</div>
</template>
<script>
import { VueAutosuggest } from 'vue-autosuggest'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BButton,BFormTextarea,BFormRating,BFormCheckbox,BFormCheckboxGroup,BFormSpinbutton,BTable,BPagination,BFormInvalidFeedback
} from 'bootstrap-vue'

import {
  BCard, BMedia, BAvatar, BCardText, BMediaAside, BMediaBody, BImg, BFormFile, BLink, BBadge, BSidebar, VBToggle,
  BInputGroup, BInputGroupAppend, BModal,
} from 'bootstrap-vue'
import {
  required, email, confirmed, url, between, alpha, integer, password, min, digits, alphaDash, length,
} from '@validations'
import BCardActions from '../../../@core/components/b-card-actions/BCardActions.vue'
import axios from '@axios'


//popup
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { ref } from '@vue/composition-api'
import { isDynamicRouteActive } from '@core/utils/utils'
import EnquiryMail from './EnquiryMail.vue'
import router from '@/router'
import draggable from 'vuedraggable'

import FormComment from './FormComment.vue'

/* eslint-disable global-require */

// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import emailjs from 'emailjs-com';
import { useClipboard } from '@vueuse/core'

export default {
    components: {
        BCardActions,
        VueAutosuggest,
        ValidationProvider,
        ValidationObserver,
        BFormInput,
        BFormGroup,
        BForm,
        BRow,
        BCol,
        BButton,
        BFormTextarea,
        BFormRating,
        BFormSpinbutton,
        BFormInvalidFeedback,
        vSelect,
        BFormCheckbox,
        BFormCheckboxGroup,
        BCard, BMedia, BAvatar, BCardText, BMediaAside, BMediaBody, BImg, BFormFile, BLink,
        BTable,BPagination,
        BBadge,
        EnquiryMail,
        BSidebar,
        quillEditor,
        draggable,
        FormComment,
        BInputGroup, BInputGroupAppend,
        BModal,
  },
  data(){
      return{
          id:router.currentRoute.params.id,
          selectAlled:false,
          userData: JSON.parse(localStorage.getItem('userData')),
          unit:null,
          floor:null,
          types:null,
          building:null,
          bedroom:null,
          sqm_min:null,
          sqm_max:null,
          sqm_min_display:'',
          sqm_max_display:'',
          price_rent_min:null,
          price_rent_max:null,
          price_rent_min_display:'',
          price_rent_max_display:'',
          price_sale_min:null,
          price_sale_max:null,
          price_sale_min_display:'',
          price_sale_max_display:'',
            price_min:null,
          price_max:null,
          action_id:null,
          mail:{
            subject:'Property Listing for you',
            mailto:null,
            mailcc:null,
            message:null
          },
           options: {
        handle: '.handle'
      },
      statusId:'',
          pmails:[],
          isSidebarMailOpen:false,
          showPropertyModal: false,
          showMobileFilters: false,
          modalSelected: [],
          modalSortBy: null,
          modalSortDesc: false,
          timestamp:null,
          input:{
              title:null,
              description:null,
              looking:null,
              fors:null,
              enquiry_source:null,
              bedroom:0,
              bathroom:1,
              buy_min:null,
              buy_max:null,
              rent_min:null,
              rent_max:null,
              zone_id:null,
              bts_id:null,
              mrt_id:null,
              airport_id:null,
              place_id:null,
              ccEmails: [],
              is_subscript: true,
              assigned_user_id: null,
              assigned_user_type: null,
          },
          place_id:'',
          zone:[],
          bts:[],
          mrt:[],
          airport:[],
          properties:[],
          
          users:[],
          users_selected:[],
          properties_selected:[],
          clientTypeId: null,
          clientLineId: null,
          coAgentSubmission: null,
          coAgentCustomerMatches: null,
          checkingCoAgentMatch: false,
          approvingCoAgent: false,
          assign_user_type: null,
          assigned_users_list: [],
          agent_customers: [],
          agent_customers_loading: false,
          user_type_options: [
            { id: 'agent', title: 'Agent' },
            { id: 'admin', title: 'Admin' },
          ],
         properties_mail:[],
          filter_user:null,
          option_looking: 
            [
            { id: "Sale & Rent", title: 'Sale & Rent' }, 
            { id: "Sale", title: 'Sale' }, 
            { id: "Rent", title: 'Rent' }, 
          
         ],
         option_fors: 
        [
            { id: "Own Stay", title: 'Own Stay' }, 
            { id: "Investment", title: 'Investment' }, 
           
          
         ],
         option_sources:[
            { id: "Walk-in", title: 'Walk-in' }, 
            { id: "Call in", title: 'Call in' }, 
            { id: "At Site", title: 'At Site' }, 
            { id: "Website", title: 'Website' }, 
            { id: "Our Website", title: 'Our Website' }, 
            { id: "Refer", title: 'Refer' }, 
            { id: "Co-Agent", title: 'Co-Agent' }, 
            { id: "Other", title: 'Other' }, 

         ],
         inputProps: {
            id: 'autosuggest__input_ajax',
            placeholder: 'Property Pin',
            class: 'form-control',
            name: 'pin_id',
        },
        suggestions: [],
        sectionConfigs: {
            place: {
                limit: 6,
                label: 'Place',
                onSelected: selected => {
                    this.input.place_id = selected.item.id;
                        this.properties = [];
                    this.currentPage = 1
                   this.searchQuery = selected.item.name;
                    this.get_properties();
                    
                    
                },
            },
        },
        searchQuery:'',
        propertyfilter:null,
        ownerfilter:null,
        modalPlaceKeyword: null,
        perPage: 5,
        perPagep: 15,
        offset:0,
        pageOptions: [3, 5, 10],
        totalRows: 0,
        totalRowsSelected: 1,
        currentPage: 1,
        currentpsPage:1,
        currentpPage:1,
        currentPageSelected: 1,
        currentpPageSelected:1,
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        totalpRows:0,
         totalpsRows:0,
          bts_id:'',
        zone_id:'',
        mrt_id:'',
        airport_id:'',
        ps :[],
         fields_propertiesmail:[
            {
                key: 'id', label: '', tdClass:"text-center",
            },
           
            {
                key: 'image', label: 'Image', tdClass:'width-300 p-1',
            },
            {
                key: 'property', label: 'Property Code',
            },
             {
                key: 'owner', label: 'Owner',
            },
            {
                key: 'units', label: 'units',
            },
            {
                key: 'floors', label: 'Floor',
            },
            {
                key: 'type_name', label: 'Type',
            },
            {
                key: 'buildiing', label: 'Building',
            },
            {
                key: 'bedroom', label: 'Bd',
            },
            {
                key: 'sqm', label: 'Sqm',
            },
            {
                key: 'price_rent', label: 'Rent',
            },
            {
                key: 'price_sale', label: 'Sale',
            },
            {
                key: 'exp', label: 'Exp/Avail Date  ',
            },
            // {
            //     key: 'rating', label: 'Rating',
            // },
            {
                key: 'furniture_name', label: 'Furniture',
            },
            {
                key: 'bts_name', label: 'BTS',
            },
            {
                key: 'mrt_name', label: 'MRT',
            },
            {
                key: 'zone_name', label: 'Zone',
            },
             {
                key: 'id', label: 'ID',
            },
            
            
        ],
        fields_propertiesselected:[
            {
                key: 'id', label: '',
            },
             {
                key: 'handle', label: '',
            },
          
            {
                key: 'image', label: 'Image', tdClass:'width-300 p-1',
            },
            {
                key: 'property', label: 'Property Code',
            },
             {
                key: 'owner', label: 'Owner',
            },
            {
                key: 'units', label: 'units',
            },
            {
                key: 'floors', label: 'Floor',
            },
            {
                key: 'type_name', label: 'Type',
            },
            {
                key: 'close_deal', label: 'Close Deal',
            },
            {
                key: 'buildiing', label: 'Building',
            },
            {
                key: 'bedroom', label: 'Bd',
            },
            {
                key: 'sqm', label: 'Sqm',
            },
            {
                key: 'price_rent', label: 'Rent',
            },
            {
                key: 'price_sale', label: 'Sale',
            },
            {
                key: 'exp', label: 'Exp/Avail Date  ',
            },
            // {
            //     key: 'rating', label: 'Rating',
            // },
            {
                key: 'furniture_name', label: 'Furniture',
            },
            {
                key: 'bts_name', label: 'BTS',
            },
            {
                key: 'mrt_name', label: 'MRT',
            },
            {
                key: 'zone_name', label: 'Zone',
            },
             {
                key: 'id', label: 'ID',
            },
            
            
        ],
        fields_properties:[
            {
                key: 'id', label: '',
            },

            {
                key: 'image', label: 'Image', tdClass:'width-300 p-0',
            },
            {
                key: 'property', label: 'Property Code',
            },
             {
                key: 'owner', label: 'Owner',
            },
            {
                key: 'units', label: 'units',
            },
            {
                key: 'floors', label: 'Floor', sortable: true,
            },
            {
                key: 'type_name', label: 'Type',
            },
            {
                key: 'buildiing', label: 'Building',
            },
            {
                key: 'bedroom', label: 'Bd', sortable: true,
            },
            {
                key: 'sqm', label: 'Sqm', sortable: true,
            },
            {
                key: 'price_rent', label: 'Rent', sortable: true,
            },
            {
                key: 'price_sale', label: 'Sale', sortable: true,
            },
            {
                key: 'exp', label: 'Exp/Avail Date  ',
            },
            // {
            //     key: 'rating', label: 'Rating',
            // },
            {
                key: 'furniture_name', label: 'Furniture',
            },
            {
                key: 'bts_name', label: 'BTS',
            },
            {
                key: 'mrt_name', label: 'MRT',
            },
            {
                key: 'zone_name', label: 'Zone',
            },
             {
                key: 'id', label: 'ID',
            },
            
            
        ],
        fields: [
            {
                key: 'id', label: '',
            },
            {
                key: 'name', label: 'ชื่อ-นามสกุล',
            },
             {
                key: 'email', label: 'อีเมล',
            },
             {
                key: 'phone', label: 'เบอร์โทรศัพท์',
            },
       
      
        ],
        newEmail: '',
        defaultEmails: [],
      }
  },
  directives: {
   
     'b-toggle': VBToggle,
      Ripple,
  },
  created(){
     this.get_properties();
      this.getZone();
      this.getBts();
      this.getMrt();
      this.getAirport();
      this.getDefaultEmail()
     setTimeout(() => {
          this.getData();
     }, 500);
     this.getNow();
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    currentLocale() {
        return  this.$i18n.locale;
    },
    activeFilterCount() {
        return [
            this.propertyfilter, this.ownerfilter, this.building,
            this.unit, this.types, this.floor, this.bedroom,
            this.sqm_min, this.sqm_max,
            this.price_rent_min, this.price_rent_max,
            this.price_sale_min, this.price_sale_max,
            this.statusId === '1' ? '1' : null,
            this.modalPlaceKeyword,
        ].filter(v => v !== null && v !== '' && v !== undefined).length;
    },
    clientTypeLabel() {
      const map = { 3: 'Customer', 4: 'Agent', 5: 'Owner' };
      return map[this.clientTypeId] || null;
    },
    clientTypeVariant() {
      const map = { 3: 'light-info', 4: 'light-warning', 5: 'light-success' };
      return map[this.clientTypeId] || 'light-secondary';
    },
    assignedUser() {
      if (!this.input.assigned_user_id || !this.assigned_users_list.length) return null;
      return this.assigned_users_list.find(u => u.id === this.input.assigned_user_id) || null;
    },
  },
  watch:{
   /* 'input.bedroom':function(value){
    
         this.properties = [];
         this.currentPage = 1
        this.bedroom=value;
        this.get_properties();

    },
    'input.bts_id':function(value){
        console.log('bts_id', value);
         this.properties = [];
         this.currentPage = 1
         this.bts_id= '';
         if(value){
              this.bts_id=value.id;
         }
       
        this.get_properties();

    },
    'input.zone_id':function(value){
        console.log('bedroom', value);
         this.properties = [];
         this.currentPage = 1
         this.zone_id= '';
         if(value){
              this.zone_id=value.id;
         }
        
        this.get_properties();

    },
     'input.airport_id':function(value){
        console.log('bedroom', value);
         this.properties = [];
         this.currentPage = 1
         this.airport_id= '';
         if(value){
              this.airport_id=value.id;
         }
        
        this.get_properties();

    },
    'input.mrt_id':function(value){
        console.log('bedroom', value);
         this.properties = [];
         this.currentPage = 1
          this.mrt_id= '';
         if(value){
              this.mrt_id=value.id;
         }
        
        this.get_properties();

    },
    'input.bathroom':function(value){
        console.log('bedroom', value);
         this.properties = [];
         this.currentPage = 1
        this.bathroom=value;
        this.get_properties();

    },*/
    /* 'input.rent_min':function(value){
        this.price_min = value;
        if(!this.input.rent_min && !this.input.rent_max){
             this.action_id = '';
        }else{
             this.action_id = '2,4';
        }
         this.currentPage = 1
         this.get_properties();
        

    },
    'input.rent_max':function(value){
        this.price_max = value;
      if(!this.input.rent_min && !this.input.rent_max){
             this.action_id = '';
        }else{
             this.action_id = '2,4';
        }
         this.currentPage = 1
         this.get_properties();
        

    },
    'input.buy_min':function(value){
        this.price_min = value;
         if(!this.input.buy_min && !this.input.buy_max){
             this.action_id = '';
        }else{
             this.action_id = '1,3';
        }
         this.currentPage = 1
         this.get_properties();
        

    },
    'input.buy_max':function(value){
        this.price_max = value;
        if(!this.input.buy_min && !this.input.buy_max){
             this.action_id = '';
        }else{
             this.action_id = '1,3';
        }
         this.currentPage = 1
         this.get_properties();
        

    },*/
    pmails(value){
        this.pmails = value;
        if(value.length == 0){
            this.selectAlled = false;
        }
       
        this.add_tomail();
    },
    floor(value){
        console.log('floor',value);
        this.floor = value;
         this.currentPage = 1
          this.get_properties();

    },
    building(value){
         this.building = value;
         this.currentPage = 1
          this.get_properties();

    },
      propertyfilter(value){
        this.properties = [];
        this.currentPage = 1;
        this.propertyfilter = value;
        clearTimeout(this._pinDebounce);
        this._pinDebounce = setTimeout(() => { this.get_properties(); }, 400);
      },
      ownerfilter(value){
        this.properties = [];
        this.currentPage = 1;
        this.ownerfilter = value;
        clearTimeout(this._ownerDebounce);
        this._ownerDebounce = setTimeout(() => { this.get_properties(); }, 400);
      },
      bedroom(value){
        this.properties = [];
         this.currentPage = 1
         this.bedroom = value;
        this.get_properties();
      },
      
      price_rent_min(value){
         this.properties = [];
         this.currentPage = 1
         this.price_rent_min = value;
        this.get_properties();
      },
      price_rent_max(value){
         this.properties = [];
         this.currentPage = 1
         this.price_rent_max = value;
        this.get_properties();
      },
      price_sale_min(value){
         this.properties = [];
         this.currentPage = 1
         this.price_sale_min = value;
        this.get_properties();
      },
      price_sale_max(value){
         this.properties = [];
         this.currentPage = 1
         this.price_sale_max = value;
        this.get_properties();
      },
      unit(value){
        this.properties = [];
         this.currentPage = 1
         this.unit = value;
        this.get_properties();
      },
      types(value){
        this.properties = [];
        this.currentPage = 1;
        this.types = value;
        clearTimeout(this._typeDebounce);
        this._typeDebounce = setTimeout(() => { this.get_properties(); }, 400);
      },
      sqm_min(value){
        this.properties = [];
         this.currentPage = 1
         this.sqm_min = value;
        this.get_properties();
      },
      sqm_max(value){
        this.properties = [];
         this.currentPage = 1
         this.sqm_max = value;
        this.get_properties();
      },
      modalPlaceKeyword(value){
        this.properties = [];
        this.currentpPage = 1;
        this.modalPlaceKeyword = value;
        clearTimeout(this._placeDebounce);
        this._placeDebounce = setTimeout(() => { this.get_properties(); }, 400);
      },
      filter_user(value){
           this.users = [];
          this.filter_user = value;
          this.currentPage = 1
          this.get_users();
      },
      currentPage(value){
          this.users = [];
        this.currentPage = value;
         this.get_users();
      },
      
      currentpPage(value){
           this.properties = [];
        this.currentpPage = value;
         this.get_properties();
      }

  },
  filters: {
    getcomma: function(text){
      if(!text){
        return ''

      }
			 var nStr = text;
			nStr += '';
			var x = nStr.split('.');
			var x1 = x[0];
			var x2 = x.length > 1 ? '.' + x[1] : '';
			var rgx = /(\d+)(\d{3})/;
			while (rgx.test(x1)) {
				x1 = x1.replace(rgx, '$1' + ',' + '$2');
			}
			return x1 ;
		},
  },
  methods: {
    /*
     * ลิงก์หน้าห้องบน therealtors.net สำหรับอีเมลที่ส่งให้ลูกค้า
     *
     * ⚠️ ไม่ใช่แค่เปลี่ยนโดเมน — รูปแบบ url คนละแบบกันเลย
     *   เดิม  findbangkokroom.com/condo/{ชื่อโครงการ}/{property_code}
     *   ใหม่  therealtors.net/condo/{ชื่อโครงการ}-{action}-{bedroom}-{id}
     *
     * หน้า condo ของ realvestor resolve ห้องจาก "id ที่ต่อท้าย url" ส่วนชื่อโครงการ
     * เป็นแค่ข้อความ SEO ถ้าส่ง property_code ไปแบบเดิมจะเปิดไม่เจอห้อง
     *
     * ⚠️ ตรรกะนี้ลอกมาจาก realvestor/utils/slug.ts (buildCondoUrl / slugifyPlaceName)
     * ถ้าฝั่งนั้นเปลี่ยนรูปแบบ url ต้องมาแก้ที่นี่ด้วย ไม่งั้นลิงก์ในอีเมลจะพังเงียบ ๆ
     */
    condoUrl(property) {
      if (!property || property.id == null) return 'https://therealtors.net'

      const raw = property.place_name && typeof property.place_name === 'object'
        ? (property.place_name[this.currentLocale] || Object.values(property.place_name)[0] || '')
        : (property.place_name || '')

      const name = String(raw)
        .trim()
        .toLowerCase()
        .replace(/[^\p{L}\p{M}\p{N}\s-]/gu, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-+|-+$/g, '')

      if (!name) return 'https://therealtors.net'

      /* action_name มาเป็น "Sale & Rent" ต้องแปลงเป็น Sale-Rent ให้ตรงกับฝั่งเว็บ */
      const actionById = { 1: 'Sale', 2: 'Sale-Rent', 3: 'Sale', 4: 'Rent' }
      const action = property.action_name
        ? property.action_name.replace(/\s*&\s*/g, '-')
        : (actionById[Number(property.action_id)] || 'Sale')

      const bed = Number(property.bedroom)
      const bedroom = bed ? `${bed}-bedroom` : 'Studio'

      /* en เป็นภาษาเริ่มต้นของเว็บ จึงไม่มี prefix ภาษาใน url */
      const prefix = this.currentLocale && this.currentLocale !== 'en' ? `/${this.currentLocale}` : ''

      return `https://therealtors.net${prefix}/condo/${name}-${action}-${bedroom}-${property.id}`.toLowerCase()
    },

    validateEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    },
      selectAll() {
          
            this.pmails = [];
            console.log('mla',this.pmails.length);
            if (this.selectAlled) {
               // console.log('ml',this.properties_selected);
               
               this.properties_selected.forEach(ps => {
                   this.pmails.push(ps.id);

               })
                    
                   
            }
            this.add_tomail();
        },
        change_status(){
        this.properties = []
         this.currentPage = 1
        this.get_properties();

    },
      formmail_show(){
   
        this.isSidebarMailOpen = true;
      },
       checkMove: function(e) {
      window.console.log("Future index: " + e.draggedContext.futureIndex);
    },

      add_tomail(){
          //properties_mail
          let selects = this.properties_selected;
          let pmails = this.pmails;
          console.log('pmail',selects);
          this.properties_mail  = selects;
        this.properties_mail  = pmails.map(function(value) {
             let index =  selects.findIndex(p => p.id === value);
            console.log('index',index);
            if(index > -1){  
                  return selects[index];
            }
              
        
            });

         // console.log('pmails',this.pmails);

      },
      formmail_close(){
        this.isSidebarMailOpen = false;
      },
      getNow: function() {
            const today = new Date();
            const date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
            const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
            const dateTime = date +' '+ time;
            this.timestamp = dateTime;
        },
      async getData(){
         // console.log('userdata',this.userData);
           this.mail.mailcc = this.userData.email;
           var enquiry = await axios.get('enquiry/v1/get/'+this.id);
           var enq = enquiry.data.data;
           this.input = enq;
           this.input.assigned_user_id = enq.assigned_user_id || null;
           this.input.assigned_user_type = enq.assigned_user_type || null;
           if (enq.user_id) {
             axios.get('users/v1/detail/' + enq.user_id).then(res => {
               this.clientTypeId = res.data.data.type_id || null;
               this.clientLineId = res.data.data.line_contact || null;
             });
           }
           if (enq.enquiry_source === 'Co-Agent') {
             this.get_coagent_submission(this.id);
           }
           if (enq.assigned_user_type) {
             this.assign_user_type = enq.assigned_user_type;
             await this.get_assign_users(enq.assigned_user_type);
             if (enq.assigned_user_type === 'agent' && enq.assigned_user_id) {
               this.get_agent_customers(enq.assigned_user_id);
             }
           }
           this.place_id = this.input.place_name;
           if(this.input.place_name){
               this.searchQuery = this.input.place_name;
                this.properties = [];
                this.currentPage = 1
              
                this.get_properties();

           }

            if (this.input.email && this.input.email.length > 0) {
                this.mail.mailto = this.input.email.join(", ");
            }

            if(this.input.ccEmails && this.input.ccEmails.length > 0) {
                this.mail.mailcc = this.input.ccEmails.join(", ");
            }
          
        this.mail.message = '<div>Dear ' + enq.firstname + ' ' + enq.lastname + ',</div>' +
                '<div>Thank you for your enquiry , We found properties that you might interested below detail.</div>' +
                '<div>Please &nbsp;give 1-2 days in advance for appointment</div>';                           
          
           if(enq.bts_id){
                var bts = this.bts.filter(j => j.id == enq.bts_id);
                if(bts){
                  this.input.bts_id =bts[0];
                }
           }
           if(enq.mrt_id){
                var mrt = this.mrt.filter(j => j.id == enq.mrt_id);
                if(mrt){
                  this.input.mrt_id =mrt[0];
                }
           }
           if(enq.airport_id){
                var airport = this.airport.filter(j => j.id == enq.airport_id);
                if(airport){
                  this.input.airport_id =airport[0];
                }
           }
            if(enq.zone_id){
                this.input.zone_id = enq.zone_id
            }
           if(enq.properties){
               const props = this.properties;
               let selected = [];
               enq.properties.forEach(item => {
                   selected.push(item.property_id*1);
                    
          
               });
               if(selected){
                   this.ps = selected;
                   this.get_propertyselect();
               }
               
              
               /* enq.properties.forEach(item => {
                    
                    let index =  this.properties.findIndex(p => p.id === item.property_id);
                    console.log('index',index);
                    if(index > -1){  
                         this.properties_selected.push(this.get_properties[index]);
                         this.totalpsRows = this.properties_selected.length;
                    }
                    
                    return false
                })*/

           }

           if(enq.ccEmails && enq.ccEmails.length){
            this.input.ccEmails = enq.ccEmails
           } else {
                this.input.ccEmails = this.defaultEmails
           }

           this.input.is_subscript = enq.is_subscript? true: false
            // if(enq.is_subscript) {
            //     this.input.is_subscript = enq.is_subscript? true: false
            // }

        // this.input.ccEmails = enq.ccEmails || []
           //console.log('enquiry',enquiry);
          ///enquiry/v1/get/
      },
      add_user(item){
          let index =  this.users_selected.findIndex(p => p.id === item.id);
          if(index <  0){
            this.users_selected.push(item);
            this.totalRowsSelected = this.users_selected.length;
          }
          
        

      },
      async add_property(item){
          let index =  this.properties_selected.findIndex(p => p.id === item.id);
          if(index <  0){
            //
            let inp = {}
            inp.id = this.id
            inp.property_id =item.id;
            const inps = JSON.stringify(inp);
            let result = await axios.post('enquiry/v1/addEnquiryprop', inps);
            this.properties_selected.push(item);
            this.totalpsRows = this.properties_selected.length;
          }

      },
      remove_user(id){
          
        this.users_selected = this.users_selected.filter(v => v.id  != id);
        /* this.users_selected= $.grep(this.users_selected, function(e){ 
                return e.id != id; 
            });*/
          this.totalRowsSelected = this.users_selected.length;
          
       

      },
      async remove_property(id){
          this.properties_selected = this.properties_selected.filter(v => v.id  != id);
          
            let result = await axios.delete('enquiry/v1/removeEnquiryprop/'+this.id+'/'+id);
       
          this.totalpsRows = this.properties_selected.length;
      },
      async get_propertyselect(){
           let data = {
            perpage: 40,
            offset:0,
       
            bedroom:this.bedroom,
            unit:this.unit,
            sqm:this.sqm,
            statusId:null,
            price_sale:null,
            price_rent:null,
           enq_id:this.id
         }
         
         data = JSON.stringify(data);
        let pf = await axios.post('cache-master/v1/property-filter', data);
        console.log('data_selected',pf);
        if(pf.data){
             this.properties_selected = pf.data.data;
          
             this.totalpsRows = pf.data.total;
         }else{
             this.totalpsRows = 0;
         }
          console.log('properties_selected',this.properties_selected);
           // this.properties_selected = selected;
               //  this.totalpsRows = this.properties_selected.length;

      },
      async get_properties(){
          const offset =  this.perPagep*(this.currentpPage-1);
        let data = {
            perpage: this.perPagep,
            offset:offset,
       
            bedroom:this.bedroom,
            unit:this.unit,
            sqm_min:this.sqm_min,
            sqm_max:this.sqm_max,
            statusId:this.statusId==="1"?this.statusId:null,
            price_rent_min:this.price_rent_min,
            price_rent_max:this.price_rent_max,
            price_sale_min:this.price_sale_min,
            price_sale_max:this.price_sale_max,
             bts_id:this.bts_id,
            mrt_id:this.mrt_id,
            zone_id:this.zone_id,
            airport_id:this.airport_id,
             propertyfilter:this.propertyfilter,
            ownerfilter:this.ownerfilter,
            keyword: this.searchQuery || null,
            place_keyword: this.modalPlaceKeyword || null,
            price_min:this.price_min,
            price_max:this.price_max,
            action_id:this.action_id,
            floors:this.floor,
            building:this.building,
            type_name:this.types,
            sortBy:this.modalSortBy,
            sortDesc:this.modalSortDesc ? 'DESC' : 'ASC',
         }
         data = JSON.stringify(data);
        let properties = await axios.post('v1/enquiry/property-filter', data);
        if(properties.data){
             this.properties = properties.data.data;
          
             this.totalpRows = properties.data.total;
         }else{
             this.totalpRows = 0;
         }
        console.log('properties',properties);

      },
      async get_users(){
         
         const offset =  this.perPage*(this.currentPage-1);
         console.log('filter',this.filter_user );
         let data = {
            perpage: this.perPage,
            offset:offset,
            keyword:this.filter_user
            
            
         }
         data = JSON.stringify(data);
         var users = await axios.post('/users/v1/lists/3', data);
         if(users.data){
             this.users = users.data.data;
            console.log('users',this.users);
             this.totalRows = users.data.total;
         }else{
             this.totalRows = 0;
         }
         
        

      },
      getAirport(){
          axios.get('transit/v1/listtype/airport')
            .then(res => { 
            // console.log('res',res);
                this.airport = res.data.data; 
            })
      },
      getMrt(){
          axios.get('transit/v1/listtype/mrt')
            .then(res => { 
            // console.log('res',res);
                this.mrt = res.data.data; 
            })
      },
      getBts(){
          axios.get('transit/v1/listtype/bts')
            .then(res => { 
            // console.log('res',res);
                this.bts = res.data.data; 
            })
      },
      getZone(){
         let queryParams1 = {
            perpage: 1000,
            offset:0
        
        }
        let data1 = JSON.stringify(queryParams1);
         
        axios.post('zone/v1/lists',data1)
        .then(res => { 
            
            this.zone = res.data.data; 
        })
      },
     
        fetchResults() {
        const { place_id } = this
        console.log('query',place_id);
        if(place_id){

        
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                var data = JSON.stringify({
                    "keyword": place_id
                    });
                const placePromise = axios.post('autocomplete/v1/place',data)
            
                

                Promise.all([placePromise]).then(values => {
                    this.suggestions = []
                this.selected = null
                    console.log('values', values[0].data.data);
                    var data =  values[0].data.data;
                    this.suggestions.push({ name: 'place', data: data })
                
                // this.suggestions.push();
                }).catch(error=>{
                    console.log('error', error)
                })
            }, this.debounceMilliseconds)
        }else{
            this.suggestions = []
        }
        },
        
        filterResults(data, text, field) {
        return data.filter(item => {
            if (item[field].toLowerCase().indexOf(text.toLowerCase()) > -1) {
            return item[field]
            }
            return false
        }).sort()
        },
        renderSuggestion(suggestion) {
            console.log('suggestion',suggestion);
        
        return suggestion.item.name
        },
        getSuggestionValue(suggestion) {
        const { name, item } = suggestion
        console.log('suggestion',suggestion);
        
        return name === 'hotels' ? item.title : item.name
        },
          doCopy(Pname,Pcode) {
      this.$copyText('https://findbangkokroom.com/condo/'+(Pname ? Pname.replace(/\s/g,'-') : '')+'/'+Pcode).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Text copied',
            icon: 'BellIcon',
          },
        })
      }, e => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Can not copy!',
            icon: 'BellIcon',
          },
        })
      })
    },
    makeToast(variant = null,title,message) {
      this.$bvToast.toast(message, {
        title: title,
        variant,
        solid: true,
      })
    },
    async sendMail(){
        let message =  this.$refs.templateMail.innerHTML;
        
      /*  var templateParams = {
            subject: this.mail.subject,
            name: 'James',
            notes: 'Check this out!',
            message: message,
            code: this.input.code,
            properties:this.properties_selected,
            email:this.mail.mailto
        };*/
        const convertEmails = this.mail.mailto.split(",").map(email => email.trim());
        const convertccEmails = this.mail.mailcc.split(",").map(email => email.trim());
        let params = {
            to: convertEmails,
            cc: convertccEmails,
            //from:this.userData.name+' <'+this.userData.email+'>',
            from:'"'+this.userData.name+'" <no-reply@therealtors.net>',
            replyTo:this.userData.email,
            subject:this.mail.subject,
            message: message,
        }
       console.log('templateParams',params);

      try {
      /* let status = await emailjs.send('service_ko4kafc', 'template_yi1voc8', templateParams,
        'user_Y1lQ1v5Hbn27P4BQhuayo', {
          name: 'FBR',
          email: 'deoz@windowslive.com',
          message:'texst'
        })*/
        var data = JSON.stringify(params);
        let response = await axios.post('enquiry/v1/email/send',data);
        if(response.data.success){
           this.makeToast('sucess','Send Mail',"done.");
            
        }else{
              this.makeToast('danger','Error 403',"Please, sen mail again.");

        }
        this.formmail_close();
        
       
      } catch(error) {
          console.log({error})
      }

    },
     validationMailForm(event) {
          this.$refs.refFormObserver.validate().then(success => {
            if(success){
                this.sendMail();

               
               
            }
          });
     },
     
      validationForm(event) {
          /*this.$refs.refFormObserver.validate().then(success => {
            if(success){
                this.sendMail();

               
               
            }
          });*/
         
          this.$refs.simpleRules.validate().then(success => {
               if (success) {
                    
                   if(this.properties_selected.length == 0){
                           this.makeToast('danger','Error 403',"Please, select room.");
                   }else{
                       this.input.properties = this.properties_selected;
                       this.input.created_by = this.userData.id;
                       
                       //this.input.users = this.users_selected;
                       var data = JSON.stringify(this.input);
                      //console.log('data',data);
                       
                           axios.put('enquiry/v1/update/'+this.id,data)
                            .then(res => { 
                                console.log('res',res);
                                if(!res.data.success){
                                    this.makeToast('danger','Error 403',res.data.message);
                                
                                
                                }else{
                                // this.$router.push('/enquiry/lists', () => {
                                    this.$toast({
                                        component: ToastificationContent,
                                        position: 'top-right',
                                        props: {
                                        title: `Done`,
                                        icon: 'CoffeeIcon',
                                        variant: 'success',
                                        text: `You have successfully created.`,
                                        },
                                    })
                                // });
                                

                                }
                            // this.actions = res.data.data; 
                            }).catch(error => {
                                this.makeToast('danger','Error 403',error);
                                console.log('error',error);
                            })

                       
                   }
                   
               }
          });
      },
    addEmail() {
        const email = this.newEmail.trim()
        if (email && this.validateEmail(email)) {
            this.input.ccEmails.push(email)
            this.newEmail = ''
        } else if (email) {
            alert('Invalid email format')
        }
    },
    removeEmail(index) {
        this.input.ccEmails.splice(index, 1)
    },
    validateEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return re.test(email)
    },
    getDefaultEmail() {
        axios.get('enquiry/v1/email/getDefault')
            .then(res => {
                const response = res?.data?.data;
                // this.defaultEmails = response.map(e => e.email)
                this.defaultEmails = response
            })
    },
    openPropertyModal() {
        this.modalSelected = [...this.properties_selected];
        this.showPropertyModal = true;
    },
    onModalSortChanged(ctx) {
        const colMap = {
            price_rent: 'rent_price',
            price_sale: 'sale_price',
        };
        this.modalSortBy = colMap[ctx.sortBy] || ctx.sortBy;
        this.modalSortDesc = ctx.sortDesc;
        this.currentpPage = 1;
        this.get_properties();
    },
    applyModalSelection() {
        // add newly checked properties
        this.modalSelected.forEach(item => {
            this.add_property(item);
        });
        // remove properties that were unchecked in the modal
        const selectedIds = this.modalSelected.map(i => i.id);
        const toRemove = this.properties_selected.filter(p => !selectedIds.includes(p.id));
        toRemove.forEach(item => {
            this.remove_property(item.id);
        });
        this.modalSelected = [];
        this.showPropertyModal = false;
    },
    resetModalFilters() {
        this.propertyfilter = null;
        this.ownerfilter = null;
        this.building = null;
        this.unit = null;
        this.floor = null;
        this.bedroom = null;
        this.sqm_min = null;
        this.sqm_max = null;
        this.price_rent_min = null;
        this.price_rent_max = null;
        this.price_sale_min = null;
        this.price_sale_max = null;
        this.sqm_min_display = '';
        this.sqm_max_display = '';
        this.price_rent_min_display = '';
        this.price_rent_max_display = '';
        this.price_sale_min_display = '';
        this.price_sale_max_display = '';
        this.statusId = '';
        this.modalPlaceKeyword = null;
        this.types = null;
        this.get_properties();
    },
    handleNumericInput(rawField, displayField, val) {
      const raw = val.replace(/[^0-9]/g, '');
      this[rawField] = raw ? raw : null;
      this[displayField] = raw ? Number(raw).toLocaleString('en') : '';
    },
    onUserTypeChange(type) {
      this.input.assigned_user_id = null;
      this.input.assigned_user_type = type;
      this.assigned_users_list = [];
      this.agent_customers = [];
      if (type) {
        this.get_assign_users(type);
      }
    },
    onAssignUserChange(userId) {
      this.agent_customers = [];
      if (this.assign_user_type === 'agent' && userId) {
        this.get_agent_customers(userId);
      }
    },
    async get_assign_users(userType) {
      const endpoint = userType === 'agent' ? '/users/v1/lists/4' : '/users/v1/lists';
      const data = JSON.stringify({ perpage: 200, offset: 0 });
      const res = await axios.post(endpoint, data);
      console.log('check image', res)
      if (res.data && res.data.data) {
        this.assigned_users_list = res.data.data.map(u => ({
          ...u,
          fullname: [u.firstname, u.lastname].filter(Boolean).join(' ') || u.email || '',
        }));
      }
    },
    async get_coagent_submission(enquiryId) {
      try {
        const res = await axios.get(`/co-agent/v1/enquiry/by-enquiry/${enquiryId}`);
        if (res.data && res.data.data) {
          this.coAgentSubmission = res.data.data;
          if (this.coAgentSubmission.customer) {
            this.checkCoAgentCustomerMatch(this.coAgentSubmission.customer);
          }
        }
      } catch (e) {
        this.coAgentSubmission = null;
      }
    },
    async checkCoAgentCustomerMatch(customer) {
      const { firstname, lastname, phone, email } = customer || {};
      if (!firstname && !lastname && !phone && !email) return;

      this.checkingCoAgentMatch = true;
      this.coAgentCustomerMatches = null;

      try {
        const searches = [];
        if (email) searches.push(axios.post('/users/v1/lists/3', JSON.stringify({ perpage: 20, offset: 0, keyword: email })));
        if (phone) searches.push(axios.post('/users/v1/lists/3', JSON.stringify({ perpage: 20, offset: 0, keyword: phone })));
        if (!email && !phone && (firstname || lastname)) {
          searches.push(axios.post('/users/v1/lists/3', JSON.stringify({ perpage: 20, offset: 0, keyword: [firstname, lastname].filter(Boolean).join(' ') })));
        }

        const results = await Promise.all(searches);
        const seen = new Set();
        const allClients = [];
        results.forEach(res => {
          if (res.data && res.data.data) {
            res.data.data.forEach(client => {
              if (!seen.has(client.id)) {
                seen.add(client.id);
                allClients.push(client);
              }
            });
          }
        });

        this.coAgentCustomerMatches = allClients.filter(client => {
          const clientEmails = Array.isArray(client.email) ? client.email : (client.email ? [client.email] : []);
          const clientPhones = Array.isArray(client.phone) ? client.phone : (client.phone ? [client.phone] : []);
          const emailMatch = email && clientEmails.some(e => e === email);
          const phoneMatch = phone && clientPhones.some(p => p === phone);
          const nameMatch = firstname && lastname && client.firstname === firstname && client.lastname === lastname;
          return emailMatch || phoneMatch || nameMatch;
        });
      } catch (e) {
        this.coAgentCustomerMatches = [];
      }

      this.checkingCoAgentMatch = false;
    },
    coAgentStatusVariant(status) {
      if (status === 'approved') return 'light-success';
      if (status === 'rejected') return 'light-danger';
      return 'light-warning';
    },
    async approveCoAgentSubmission() {
      this.approvingCoAgent = true;
      try {
        const res = await axios.put(`/co-agent/v1/enquiry/approve/${this.coAgentSubmission.id}`);
        if (res.data && res.data.success) {
          this.coAgentSubmission = { ...this.coAgentSubmission, co_agent_status: 'approved' };
          this.$toast({
            component: ToastificationContent,
            props: { title: 'Approved', icon: 'CheckCircleIcon', variant: 'success' },
          });
        } else {
          this.makeToast('danger', 'Error', res.data.message || 'Failed to approve');
        }
      } catch (e) {
        this.makeToast('danger', 'Error', e.message || 'Failed to approve');
      }
      this.approvingCoAgent = false;
    },
    async get_agent_customers(agentId) {
      this.agent_customers_loading = true;
      const data = JSON.stringify({ perpage: 200, offset: 0, agent_id: agentId });
      const res = await axios.post('/users/v1/lists/3', data);
      if (res.data && res.data.data) {
        this.agent_customers = res.data.data;
      } else {
        this.agent_customers = [];
      }
      this.agent_customers_loading = false;
    },
  }
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-autosuggest.scss';
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/pages/ui-feather.scss';

.client-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: #7367f0;
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &--sm {
    width: 36px;
    height: 36px;
    min-width: 36px;
    font-size: 14px;
  }
}

.agent-customer-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
}

.agent-customer-avatar {
  width: 28px;
  height: 28px;
  min-width: 28px;
  border-radius: 50%;
  background-color: #ea5455;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact-row {
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.section-label {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #b9b9c3;
}

.email-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.email-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 1.5px solid #80AC03;
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 0.82rem;
  color: #80AC03;
  font-weight: 500;
}

.remove-chip {
  cursor: pointer;
  color: #ea5455;
  flex-shrink: 0;
  transition: opacity 0.15s;

  &:hover {
    opacity: 0.7;
  }
}

.subscription-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
}

.cursor-grab {
  cursor: grab;
}

.property-modal-split {
  display: flex;
  height: 82vh;
  overflow: hidden;
  position: relative;
}

.property-modal-sidebar {
  width: 220px;
  min-width: 220px;
  border-right: 1px solid #ebe9f1;
  overflow-y: auto;
  padding: 1rem;
  background-color: #f8f8f8;

  .filter-field-label {
    font-size: 0.75rem !important;
    color: #6e6b7b !important;
    margin-bottom: 3px !important;
    font-weight: 500 !important;
  }

  .form-group {
    margin-bottom: 0.75rem;
  }
}

.property-modal-results {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-width: 0;
}

.mobile-filter-bar {
  border-bottom: 1px solid #ebe9f1;
  background: #fff;
}

.modal-footer-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .modal-footer-actions {
    display: flex;
    gap: 8px;
  }
}

@media (max-width: 575px) {
  .modal-footer-inner {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;

    .modal-footer-count {
      text-align: center;
    }

    .modal-footer-actions {
      display: flex;
      gap: 8px;

      .btn {
        flex: 1;
      }
    }
  }
}

.mobile-filter-backdrop {
  display: none;
}

@media (max-width: 767px) {
  .property-modal-split {
    height: 78vh;
  }

  .property-modal-sidebar {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 280px;
    min-width: 280px;
    z-index: 100;
    transform: translateX(-100%);
    transition: transform 0.25s ease;
    box-shadow: none;

    &.mobile-open {
      transform: translateX(0);
      box-shadow: 4px 0 16px rgba(0, 0, 0, 0.15);
    }
  }

  .mobile-filter-backdrop {
    display: block;
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 99;
  }
}
</style>
